import Vue from "vue";
import "./styles/index.scss";

import NaFooter from "@/components/common/footer/Footer.vue";
import NaHeader from "@/components/common/header/Header.vue";
import LangSelect from "@/components/common/lang.select/LangSelect.vue";
import Select from "@/components/common/select/Select.vue";
import PageContainer from "@/components/common/page.container/PageContainer.vue";
import PopupContainer from "@/components/common/popup.container/PopupContainer.vue";
import ToTopBtn from "@/components/common/to.top.button/ToTopBtn.vue";
import Cookie from "@/components/common/cookie/Cookie.vue";
import ChangeLang from "@/components/common/change.lang/ChangeLang.vue";
import LongCardPreload from "@/components/common/preloaders/LongCardPreloader.vue";
import LinePreload from "@/components/common/preloaders/LinePreload.vue";
import BannerCouponPreload from "@/components/common/preloaders/BannerCouponPreload.vue";
import CardPreload from "@/components/common/preloaders/CardPreload.vue";
import MerchantPreload from "@/components/common/preloaders/MerchantPreload.vue";
import RequestError from "@/components/common/request.error/RequestError.vue";
import LoadMorePreload from "@/components/common/load.more.preload/LoadMorePreload.vue";

Vue.component("NaFooter", NaFooter);
Vue.component("NaHeader", NaHeader);
Vue.component("LangSelect", LangSelect);
Vue.component("Select", Select);
Vue.component("PageContainer", PageContainer);
Vue.component("PopupContainer", PopupContainer);
Vue.component("ToTopBtn", ToTopBtn);
Vue.component("Cookie", Cookie);
Vue.component("ChangeLang", ChangeLang);
Vue.component("LongCardPreload", LongCardPreload);
Vue.component("LinePreload", LinePreload);
Vue.component("BannerCouponPreload", BannerCouponPreload);
Vue.component("CardPreload", CardPreload);
Vue.component("MerchantPreload", MerchantPreload);
Vue.component("RequestError", RequestError);
Vue.component("LoadMorePreload", LoadMorePreload);

// directive
import TextPreload from "@/components/common/directives/TextPreload.ts";
// @ts-ignore: Unreachable code error
Vue.directive("text-preload", TextPreload);
import ImgPreload from "@/components/common/directives/ImgPreload.ts";
// @ts-ignore: Unreachable code error
Vue.directive("img-preload", ImgPreload);
import CorrectImg from "@/components/common/directives/CorrectImg.ts";
// @ts-ignore: Unreachable code error
Vue.directive("correct-img", CorrectImg);
import DotText from "@/components/common/directives/DotText.ts";
// @ts-ignore: Unreachable code error
Vue.directive("dot-text", DotText);

// Libs
import { ContentLoader } from "vue-content-loader";
Vue.component("content-loader", ContentLoader);

import VueScrollTo from "vue-scrollto";
import axios from "axios";
import VueAxios from "vue-axios";
import lineClamp from "vue-line-clamp";
import VTooltip from "v-tooltip";

Vue.use(VueScrollTo, VueAxios, axios);
Vue.use(lineClamp, {});
Vue.use(VTooltip);
